import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { clearNavigationState } from "../redux/navigation/navigationActions";


export function useAutoClearNavigation() {
  const dispatch = useDispatch();
  const navState = useSelector((state) => state.navigation);
  const currentPage = window.location.pathname;

  useEffect(() => {
    if (!navState || !navState.page) return;

    if (navState.page !== currentPage) {
      // User left the page where the state should be used → clear it
      dispatch(clearNavigationState());
    }
  }, [currentPage]);
}
